<template>
  <div class="main">
    <!-- 标题  -->
    <p class="title-Individual-center">
      <span>人才资源管理</span>
      <i class="el-icon-arrow-right"></i>
      <span class="span-Individual-center">员工信息回收站</span>
    </p>
    <div class="box">
      <el-form
        label-position="left"
        :inline="true"
        :model="ruleForm"
        ref="ruleForm"
        label-suffix="："
        class="demo-ruleForm"
      >
        <el-form-item label="姓名">
          <el-input
            v-model="ruleForm.name"
            placeholder="请输入员工姓名"
            style="width: 150px"
          ></el-input>
        </el-form-item>
        <el-form-item label="身份证号" style="margin: 0 30px">
          <el-input
            v-model="ruleForm.idNumber"
            placeholder="请输入身份证号"
            style="width: 150px"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input
            v-model="ruleForm.phone"
            placeholder="请输入联系方式"
            style="width: 150px; margin-right: 150px"
          ></el-input>
        </el-form-item>
        <el-form-item label="入职时间">
          <el-date-picker
            v-model="ruleForm.dateTime"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            unlink-panels
            @change="daterangeChange"
            start-placeholder="请选择"
            end-placeholder="请选择"
            style="width: 240px"
            clearable
            @clear="ruleForm.dateTime = null"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item style="margin-left: 20px">
          <el-button
            type="primary"
            @click="submitForm('ruleForm')"
            style="width: 75px"
            >搜索</el-button
          >
          <el-button @click="resetForm('ruleForm')" style="width: 75px"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
      <div style="float: right; margin-bottom: 20px">
        <el-button type="primary" style="width: 110px" @click="onRestore('')"
          >批量恢复<span v-if="closeList.length > 0"
            >({{ closeList.length }})</span
          ></el-button
        >
        <el-button
          type="primary"
          style="width: 110px; margin-left: 30px"
          @click="onClose('')"
          >批量删除
          <span v-if="closeList.length > 0"
            >({{ closeList.length }})</span
          ></el-button
        >
      </div>
      <el-table
        ref="multipleTable"
        :data="tableData"
        :row-class-name="tableRowClassName"
        :cell-style="{ 'text-align': 'center', fontSize: '12px' }"
        :header-cell-style="{
          background: '#409eff ',
          color: '#fff',
          'text-align': 'center',
          fontWeight: 300,
          fontSize: '12px',
        }"
        row-key="id"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="45" :reserve-selection="true"> </el-table-column>
        <el-table-column prop="name" label="姓名" show-overflow-tooltip width="120">
        </el-table-column>
        <el-table-column prop="sexName" label="性别" width="120"> </el-table-column>
        <el-table-column prop="age" label="年龄" show-overflow-tooltip width="120">
        </el-table-column>
        <el-table-column prop="idNumber" label="身份证号" show-overflow-tooltip width="180">
        </el-table-column>
        <el-table-column prop="phone" label="联系方式" show-overflow-tooltip width="120">
        </el-table-column>
        <el-table-column prop="deptName" label="部门" show-overflow-tooltip width="120">
        </el-table-column>
        <el-table-column prop="positionName" label="职位" show-overflow-tooltip width="120">
        </el-table-column>
        <el-table-column
          prop="jobStartTime"
          label="入职时间"
          show-overflow-tooltip width="120"
        >
        </el-table-column>
        <el-table-column
          prop="jobStartTime"
          label="离职时间"
          show-overflow-tooltip width="120"
        >
        </el-table-column>
        <el-table-column
          prop="leaveOrNotName"
          label="状态"
          show-overflow-tooltip width="120"
        >
        </el-table-column>
        <el-table-column label="操作" show-overflow-tooltip width="120" fixed="right">
          <div style="display: flex; align-items: center" slot-scope="scope">
            <el-button
              type="text"
              style="font-size: 12px"
              @click="onRestore(scope.row)"
              >恢复</el-button
            >
            <el-button
              type="text"
              style="color: #fe574a; font-size: 12px"
              @click="onClose(scope.row)"
              >彻底删除</el-button
            >
          </div>
        </el-table-column>
      </el-table>
      <!-- 底部分页 -->
      <div class="paging-box">
        <div class="paging">
          <paging
            :pagingObj="pagingObj"
            @handleCurrentChange="handleCurrentChange"
          ></paging>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as API from "@/assets/api/firm/firmTalent.js";
// 引入分页组件
import paging from "../../../../components/paging.vue";
export default {
  components: {
    paging,
  },
  data() {
    return {
      //分页数据
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //总数
      },
      ruleForm: {
        companyId: this.$store.getters.getCompany.id,
        name: "",
        id: "",
        idNumber: "",
        phone: "",
        dateTime: null,
        endTime: "",
        startTime: "",
        leaveOrNot: "",
        recycleStatus: 2,
      },
      tableData: [],
      // 删除列表
      closeList: [],
    };
  },
  mounted() {
    this.employeeList();
  },
  methods: {
    // 入职时间切换
    daterangeChange(val) {
      if (Array.isArray(val) && val.length === 2 && val[0] && val[1]) {
        this.ruleForm.startTime = val[0];
        this.ruleForm.endTime = val[1];
      } else {
        this.ruleForm.startTime = "";
        this.ruleForm.endTime = "";
      }
    },
    // 查询员工
    employeeList(isTrue) {
      if (!isTrue) {
        this.$refs.multipleTable.clearSelection()
      }
      let data = {
        pageNo: this.pagingObj.currentPage,
        pageSize: this.pagingObj.pageSize,
        data: this.ruleForm,
      };
      API.employeeList(data).then((res) => {
        this.tableData = res.data.list;
      });
    },
    // 搜索
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.employeeList();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //重置
    resetForm(formName) {
      this.ruleForm = {
        companyId: this.$store.getters.getCompany.id,
        name: "",
        id: "",
        idNumber: "",
        phone: "",
        dateTime: null,
        endTime: "",
        startTime: "",
        leaveOrNot: this.isIndex2,
        recycleStatus: 2,
      };
      this.employeeList();
    },
    // 分页
    handleCurrentChange(val) {
      this.pagingObj.currentPage = val;
      this.employeeList(true);
    },
    onClose(val) {
      if (!this.$checkAction()) return
      let that = this;
      if (val) {
        this.$confirmWithScroll("是否彻底删除本条数据?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          that.batchDelete([val.id]);
        });
      } else {
        if (this.closeList.length > 0) {
          this.$confirmWithScroll("是否删除勾选中的员工数据?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            that.batchDelete(this.closeList);
          });
        } else {
          that.$tool.PromptBox("error", "请至少勾选一条数据后进行操作！");
        }
      }
    },
    // 删除
    batchDelete(ids) {
      let data = {
        data: {
          ids: ids,
          companyId: this.$store.getters.getCompany.id,
          updateTime: "",
        },
      };
      API.batchDelete(data).then((res) => {
        if (res.code == 0) {
          if (res.data.fail > 0) {
            this.$tool.PromptBox("error", res.data.reason);
          } else {
            this.$tool.PromptBox("success", "操作成功");
            this.employeeList();
          }
        }
      });
    },
    onRestore(val) {
      if (!this.$checkAction()) return
      let that = this;
      if (val) {
        this.$confirmWithScroll("是否恢复本条数据?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          that.batchRestore([val.id]);
        });
      } else {
        if (this.closeList.length > 0) {
          this.$confirmWithScroll("是否恢复勾选中的员工数据?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            that.batchRestore(this.closeList);
          });
        } else {
          that.$tool.PromptBox("error", "请至少勾选一条数据后进行操作！");
        }
      }
    },
    // 恢复
    batchRestore(ids) {
      let data = {
        data: {
          ids: ids,
          companyId: this.$store.getters.getCompany.id,
          updateTime: "",
        },
      };
      API.batchRestore(data).then((res) => {
        if (res.code == 0) {
          if (res.data.fail > 0) {
            this.$tool.PromptBox("error", res.data.reason);
          } else {
            this.$tool.PromptBox("success", "操作成功");
            this.employeeList();
          }
        }
      });
    },
    handleSelectionChange(val) {
      this.closeList = val.map((item) => item.id);
    },
    //斑马线
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "row-style";
      }
      return "";
    },
  },
};
</script>

<style lang="less" scoped>
/* 主内容区滚动条样式 */
::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  height: 8px; /* 主内容区水平滚动条高度 */
}
::v-deep .el-table__fixed-right {
  height: 100% !important; /* 覆盖默认高度计算 */
}
::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background: #c0c0c0; /* 灰色滑块，比轨道深一些 */
  border-radius: 4px; /* 可选：滑块圆角 */
}
::v-deep .el-table__body-wrapper {
  scrollbar-width: thin; /* Firefox 中"thin"约 8px 粗细 */
  scrollbar-color: #c0c0c0 #f5f5f5; /* 滑块色 + 轨道色 */
}
/deep/ .el-table .row-style {
  background: #eee;
}

/deep/.el-input__inner {
  height: 35px;
}

/deep/.el-form-item__label {
  padding: 0;
}

/deep/.el-form-item {
  margin-bottom: 30px;
}

/deep/.el-range-editor.el-input__inner {
  padding: 0 10px;
}

.box {
  width: 1200px;
  box-sizing: border-box;
  min-height: 700px;
  margin-top: 20px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(125, 125, 125, 0.5);
  border-radius: 20px;
  padding: 30px;
}

// 分页
.paging-box {
  width: 100%;
  height: 22px;
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;

  .paging {
    width: 90%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
